export interface OpenOceanTokenListResponse {
    code: number;
    data: Array<{ address: string; customAddress: string }>;
}
